import React from "react"

import {CustomIconProps} from "./type/CustomIconProps"

export const LockIcon = ({stroke = "#307ADE", size = 17, fill = "none", ...props}: CustomIconProps) => {
    return (
        <svg width={size * 0.875} height={size} viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.2223 7.41034C13.2223 10.8077 10.7668 13.992 7.40445 14.944C7.14156 15.0187 6.85845 15.0187 6.59555 14.944C3.23317 13.9928 0.777695 10.8077 0.777695 7.41034V4.27741C0.777695 3.64584 1.15959 3.0765 1.74449 2.83772L5.52765 1.28992C6.47188 0.90336 7.52968 0.90336 8.47313 1.28992L12.2563 2.83772C12.8404 3.0765 13.2223 3.64584 13.2223 4.27741V7.41034Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.19607 7.94145C8.53518 7.56111 8.69541 7.01899 8.54374 6.44421C8.40296 5.90909 7.96429 5.47275 7.42917 5.33352C6.35971 5.05508 5.39836 5.85464 5.39836 6.87899C5.39836 7.28733 5.55159 7.65911 5.80281 7.94145C5.98326 8.14368 6.05637 8.41823 5.98248 8.67879L5.68225 9.73114C5.53992 10.2281 5.91326 10.7228 6.43049 10.7228H7.57072C8.08718 10.7228 8.46052 10.2281 8.31896 9.73114L8.01873 8.67879C7.94251 8.41823 8.0164 8.14368 8.19607 7.94145V7.94145Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
